import { Link } from "react-router-dom";
import type { Film } from "@/types/content";

interface FilmCardProps {
  film: Film;
  variant?: "grid" | "scroll";
}

export default function FilmCard({ film, variant = "grid" }: FilmCardProps) {
  const widthClass = variant === "scroll" ? "w-[220px] md:w-[260px] shrink-0" : "w-full";

  return (
    <article
      className={`group ${widthClass} rounded-lg overflow-hidden bg-background-100 border border-background-200/70 flex flex-col`}
    >
      <Link to={`/films/${film.id}`} className="block relative aspect-[2/3] overflow-hidden">
        <img
          src={film.poster}
          alt={`${film.title} 球幕影院影片海报`}
          title={`${film.title} 球幕影院沉浸式影片`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/10 to-transparent opacity-70" />
        <span className="absolute top-3 left-3 px-2 py-1 rounded-md text-xs font-label bg-accent-500 text-background-50">
          {film.rating.toFixed(1)} 分
        </span>
        {film.featured && (
          <span className="absolute top-3 right-3 px-2 py-1 rounded-md text-xs font-label bg-primary-500 text-background-50">
            精选
          </span>
        )}
      </Link>
      <div className="p-4 flex flex-col gap-2 flex-1">
        <h3 className="font-heading font-semibold text-foreground-950 text-base leading-snug line-clamp-1">
          <Link to={`/films/${film.id}`} className="hover:text-accent-500 transition-colors cursor-pointer">
            {film.title}
          </Link>
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-1">
          导演 {film.director} · {film.year}
        </p>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{film.synopsis}</p>
        <div className="flex flex-wrap gap-1.5 mt-auto pt-2">
          {film.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-full text-[11px] font-label bg-secondary-100/90 text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}